import { falMagnifyingGlass } from 'shared/@generated/icons/falMagnifyingGlass';
import { Pressable, View } from 'react-native';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import dynamic from 'next/dynamic';
import { Icon } from 'shared/components/icon';
import { Text } from 'shared/components/text';
import { FullscreenModal } from 'shared/components/fullscreen-modal';
import { BaseModalRef } from 'shared/components/base-modal';

const GlobalSearchPanel = dynamic(
  () => import('shared/components/global-search-panel').then((mod) => mod.GlobalSearchPanel),
  { ssr: false },
);

export function GlobalSearch() {
  const { t } = useTranslation('web');
  const modalRef = useRef<BaseModalRef>(null);
  const close = useCallback(() => modalRef.current?.close(), []);

  return (
    <FullscreenModal
      ref={modalRef}
      centered={true}
      headerTitle={t('layout.menu.search')}
      scrollable={false}
      className={'md:h-[min(40rem,96dvh)] md:max-w-2xl'}
      contentTestID={'global-search-modal'}
      trigger={(modal) => (
        <Pressable
          accessibilityRole={'button'}
          accessibilityLabel={t('layout.search.label')}
          className={'group items-center px-1.5'}
          onPress={modal.open}
          testID={'global-search-open'}
        >
          <View className={'items-center'}>
            <Icon icon={falMagnifyingGlass} className={'text-brand-brown-dark size-6 p-[3px]'} />
            <Text className={'text-brand-brown-dark text-2xs group-hover:underline md:text-xs'}>
              {t('layout.menu.search')}
            </Text>
          </View>
        </Pressable>
      )}
    >
      <View className={'flex-1 pt-3 md:pt-4'}>
        <GlobalSearchPanel onClose={close} />
      </View>
    </FullscreenModal>
  );
}
